import { combineReducers } from 'redux';
import { default as list } from 'cost_centers/reducers/cost_centers_list_reducers';
import { default as form } from 'cost_centers/reducers/cost_centers_form_reducers';

export const costCentersReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/reducers/index.js